import { Theme, Typography, styled } from '@mui/material';

const StyledMediaTypography = styled(Typography, {
	shouldForwardProp: (prop) => prop !== 'lineClamp' && prop !== 'textColor' && prop !== 'sx',
})(
	({
		lineClamp,
		textColor,
		theme,
	}: {
		theme: Theme;
		lineClamp?: number;
		textColor: keyof Theme['palette']['text'];
	}) => ({
		...(textColor && { color: theme.palette.text[textColor] }),
		...(lineClamp && {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			...(lineClamp === 1
				? { whiteSpace: 'nowrap' }
				: {
						display: '-webkit-box',
						WebkitLineClamp: lineClamp,
						WebkitBoxOrient: 'vertical',
					}),
		}),
	}),
);

export default StyledMediaTypography;
